"use strict";

const style = require("!!css-loader!./style/index.css").default;

module.exports =`
    <style>${style}</style>
    <span class="swiftref-badge" style="visibility: hidden;"></span>
`;
